import { Icon, NotificationBadge } from '@orbita-ui/core';
import { HeaderButton } from '../AppHeader/AppHeader.styles';
import {
  NotificationBadgeContainer,
  NotificationListContainer,
  StyledNotificationContainer,
} from './HeaderNotificationContainer.styles';
import { useComponentVisible } from 'shared/hooks/useComponentVisible';
import { useContext, useEffect, useRef, useState } from 'react';
import { HeaderNotificationItem } from './HeaderNotificationItem';
import { NotificationContext } from 'shared/notifications/contexts/NotificationContext';
import { INotification } from 'shared/notifications/models/INotification';
import { nanoid } from 'nanoid';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { useLocalStorage } from 'shared/hooks/useLocalStorage';

export type IHeaderNotification = INotification & {
  checked: boolean;
  date: Date;
};
const NOTIFICATIONS_KEY = 'VHCCR_notifications';

export const HeaderNotificationContainer = () => {
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
  const { notifications: contextNotifications } = useContext(NotificationContext);
  const { getItem, saveItem } = useLocalStorage();
  const [notifications, setNotifications] = useState<IHeaderNotification[]>(
    getItem(NOTIFICATIONS_KEY) || [],
  );
  const [notificationNumber, setNotificationNumber] = useState(
    notifications.filter((n) => !n.checked).length,
  );
  const firstRender = useRef(true);

  useEffect(() => {
    if (contextNotifications.length) {
      const newNotification = contextNotifications[contextNotifications.length - 1];
      setNotifications((notif) => [
        { ...newNotification, checked: false, date: new Date() },
        ...notif,
      ]);
      setNotificationNumber((number) => number + 1);
    }
  }, [contextNotifications]);

  useEffect(() => {
    saveItem(NOTIFICATIONS_KEY, notifications.slice(0, 20));
  }, [notifications, saveItem]);

  useEffect(() => {
    if (!isComponentVisible && !firstRender.current) {
      setNotificationNumber(0);
      setNotifications((notif) => notif.map((n) => ({ ...n, checked: true })));
    }
    firstRender.current = false;
  }, [isComponentVisible]);

  const removeNotification = (index) => {
    notifications.splice(index, 1);
    setNotifications([...notifications]);
    setNotificationNumber(notifications.filter((n) => !n.checked).length);
  };

  return (
    <StyledNotificationContainer ref={ref}>
      <HeaderButton
        data-testid="notification-button"
        className={isComponentVisible ? 'active' : ''}
        onClick={() => setIsComponentVisible((isVisible) => !isVisible)}
      >
        <div>
          <Icon name="NotificationIcon" />
          <NotificationBadgeContainer>
            {!!notificationNumber && <NotificationBadge number={notificationNumber} />}
          </NotificationBadgeContainer>
        </div>
      </HeaderButton>
      <NotificationListContainer
        data-testid="container"
        style={{
          display: isComponentVisible ? 'block' : 'none',
        }}
      >
        <OverlayScrollbarsComponent className="scroll-container" element="div" defer>
          {notifications.length ? (
            notifications.slice(0, 10).map((notification, index) => (
              <div className="item" key={nanoid()}>
                <HeaderNotificationItem
                  notification={notification}
                  onClose={() => removeNotification(index)}
                />
              </div>
            ))
          ) : (
            <HeaderNotificationItem
              notification={{
                date: new Date(),
                checked: false,
                message: 'No hay notificaciones',
                type: 'info',
              }}
              onClose={() => {}}
              removeCloseIcon
              removeDate
            />
          )}
        </OverlayScrollbarsComponent>
      </NotificationListContainer>
    </StyledNotificationContainer>
  );
};
